import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { isDataLoaded } from "../../features/productSlice/productSlice";
import { useSelector } from "react-redux";
import "./ProductCard.scss";
import "bootstrap/dist/css/bootstrap.min.css";

// import firebase from 'firebase'

import "bootstrap/dist/css/bootstrap.min.css";
import PaginationButtons from "../Pagination/PaginationButtons";

const ProductCard = (props) => {
	const dataLoaded = useSelector(isDataLoaded);
	const { data } = props;

	const [currentPage, setCurrentPage] = useState(1);
	const [totalCount, setTotalCount] = useState(Object.values(data).length);
	const [pageSize, setPageSize] = useState(8);

	// console.log(data)

	const firstPage = 1;
	const lastPage = Math.ceil(Object.values(data).length / pageSize);

	const firstPageIndex = (currentPage - 1) * pageSize;
	const lastPageIndex = firstPageIndex + pageSize;

	const productsInPageValue = Object.values(data).slice(
		firstPageIndex,
		lastPageIndex
	);

	const getCorrectIndex = (presentIndex) => {
		return currentPage * pageSize - pageSize + presentIndex;
	};

	return (
		<div style={{ marginBottom: "20px" }} className="container mb-5">
			<div className="row">
				{productsInPageValue.map((index, productIndex) => (
					<div key={getCorrectIndex(productIndex)} className="card-item col-sm-4 col-md-3 mb-5 ">
						<div>
							<div className="card-inner">
								<div className="card-top">
									<Link
										to={`/product/${
											Object.keys(data)[`${getCorrectIndex(productIndex)}`]
										}`}
									>
										{" "}
										<img src={index.image_url} alt={index.image_name} />
									</Link>
								</div>
								<div className="card-bottom">
									<div className="card-info">
										<div>
											<h6>{index.product_name}</h6>
											<hr />
											<div>
												<h6>
													&#163;{index.price}
													<Link
														to={`/product/${
															Object.keys(data)[`${getCorrectIndex(productIndex)}`]
														}`}
													>
														<button className="btn btn-outline-danger float-end">
															Detail
														</button>
													</Link>
												</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
				{/* <Link to={`/movie/${data.imdbID}`}></Link> */}
			</div>

			<PaginationButtons
				firstPage={firstPage}
				lastPage={lastPage}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				totalCount={totalCount}
				setTotalCount={setTotalCount}
				pageSize={pageSize}
				setPageSize={setPageSize}
			/>
		</div>

		// <div className=''>
		//   <h4>Yes Product Card </h4>
		// </div>
	);
};

export default ProductCard;
